<template>
  <prompt
    title="基本資料修改"
    label="請輸入顯示名稱"
    :defaultValue="displayName"
    placeholder="ex. 王小明"
    @confirm="v => updateProfile({ displayName: v })" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/common/components/Prompt'

export default {
  computed: {
    ...mapState('userModule', ['displayName'])
  },
  methods: {
    ...mapActions('userModule', ['updateProfile'])
  },
  components: { Prompt }
}
</script>
